import {
  cerrarSesionCaja,
  obtenerSesionAbiertaPorPuntoYFecha,
} from "../infraestructure/supabase/cajaSesion.repository.js";

import { mapCajaSesionFromDB } from "../domain/mappers/cajaSesion.mapper.js";

export async function cerrarCajaUseCase({
  punto,
  fecha,
  usuarioId,
  saldoFinalDeclarado,
  observaciones,
}) {
  // 1️⃣ Buscar sesión abierta por punto
  const sesionAbiertaRow =  await obtenerSesionAbiertaPorPuntoYFecha(punto, fecha);

  if (!sesionAbiertaRow) {
    throw new Error(
      "[CerrarCajaUseCase] No existe una sesión de caja abierta para este punto",
    );
  }

  // 2️⃣ Validación mínima de negocio
  if (saldoFinalDeclarado == null) {
    throw new Error(
      "[CerrarCajaUseCase] El saldo final es obligatorio para cerrar la caja",
    );
  }


  // 3️⃣ Cerrar sesión (backend decide fecha y estado)
  const sesionCerradaRow = await cerrarSesionCaja({
    id_sesion: sesionAbiertaRow.id_sesion,
    id_usuario_cierre: usuarioId,
    saldo_final: saldoFinalDeclarado,
    observaciones,
  });


  return mapCajaSesionFromDB(sesionCerradaRow);
}